import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SearchTagCheckbox } from '../../model/search';
import { Settings } from '../../model/settings.model';
import { ParametersService } from '../../service/parameters.service';
import { ToastService } from '../../service/toast.service';
import { TchekService } from '../../service/tchek.service';
import { ParseFunctionService } from '../../service/parsefunction.service';
import { Company } from '../../model/company';
import 'parse';
import { Damage } from '../../model/damage.model';
import { DamageService } from '../../service/damage.service';
import { DamageFilterService } from '../../damage-filter.service';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-dropdown-filter-damage',
  templateUrl: './dropdown-filter-damage.component.html',
  styleUrls: ['./dropdown-filter-damage.component.less']
})
export class DropdownFilterDamageComponent implements OnInit {

  @Input() tchekId: string;
  @Input() company: Company
  filter: { type: string, proba: number, number: number }[] = [];
  filterShow: { type: string, proba: number, number: number }[] = [];
  timerEvent: NodeJS.Timer;
  isActive: boolean;
  allDamagesTypeList: string[] = []
  constructor(
    private readonly _parametersService: ParametersService,
    private readonly _tchekService: TchekService,
    private readonly _damageService: DamageService,
    private readonly _parseFunctionService: ParseFunctionService,
    private readonly _toastService: ToastService,
    public damageFilterService: DamageFilterService
  ) {
    this.isActive = false;
  }

  ngOnInit() {
    $(".checkbox-menu").on("change", "input[type='checkbox']", function () {
      $(this).closest("li").toggleClass("active");
    });
    $(document).on('click', '.allow-focus', function (e) {
      e.stopPropagation();
    });
    this.init()
  }

  async init() {

    this.filter = this._parametersService.getAll().filterDamage;

    await this._damageService.getByTchek(this.tchekId, false).then(
      all => {
        all.forEach(d => {
          if (this.allDamagesTypeList.includes(d.type) === false && d.isAuto === true)
            this.allDamagesTypeList.push(d.type)
        })
        this.setFilterShow()
      }
    )
  }

  setFilterShow() {
    this.filterShow = []
    this.allDamagesTypeList.forEach(dtExist => {
      if (this.filter.every(dt => { return dt.type !== dtExist }))
        this.filter.push({ type: dtExist, proba: 50, number: 1 })
    })
    this.filter.forEach(dt => {
      if (this.allDamagesTypeList.includes(dt.type) && this.filterShow.every(dte => { return dte.type !== dt.type }))
        this.filterShow[this.filterShow.length] = dt
    })
  }

  reset() {
    this.filter.forEach(el => {
      el.number = 0;
      el.proba = 0;
    });
    this._parametersService.damageFilterEdit();
  }

  change(number, type, value) {
    this.filter.forEach(element => {
      if (element.type === type) {
        if (number === 'proba') {
          element.proba = value;
        } else if (number === 'number') {
          element.number = value;
        }
        this.onEdit()
      }
    });
  }

  onEdit() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      this._parametersService.damageFilterEdit();
    }, 2000);
  }

  save() {
    this._toastService.toastOpen(true);
    console.log("save filter ", this.filter)
    this._parametersService.saveFilterDamage(this.filter).then((saved: Settings) => {
      this._toastService.toastOpen(false);
      this.filter = saved.filterDamage
      this._parametersService.damageFilterEdit();
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/element/dropdown-filter-damage/dropdown-filter-damage.component.ts